module.exports = __webpack_public_path__ + "static/media/Group244.78607021.png";